import InputTextForm from '@Fields/v2/InputTextForm'
import React from 'react'
import FormFieldProps from '@App/forms/v2/common/form-field'
import './index.scss'
import ModalPortal from '@Components/Popups/ModalPortal'
import AccountPausedPopup from '@Components/Popups/AccountPausedPopup'

interface MfaFormProps {
    codeField: FormFieldProps
    mfaType: string
    mfaContactPoint: string
    inactive: boolean
}
const MfaForm = (props: MfaFormProps) => {
    const { codeField, mfaType, mfaContactPoint, inactive } = props

    const [openPausedPopup, setOpenPausedPopup] = React.useState<boolean>(inactive)

    const isMfaEmail = mfaType === 'email'
    return (
        <>
            <ModalPortal isOpen={openPausedPopup}>
                <AccountPausedPopup onClose={() => setOpenPausedPopup(false)} />
            </ModalPortal>
            <div className="header">
                <h2>Confirm {isMfaEmail ? 'Email ' : 'Phone '} MFA</h2>
                <p>
                    We have {isMfaEmail ? 'emailed ' : 'texted '} a code to {mfaContactPoint}
                </p>
                <p>Please enter that code in the space below</p>
                <p className="disclaimer">NOTE: MFA codes expire after 15 minutes</p>
                <InputTextForm {...codeField} />
            </div>
        </>
    )
}
export default MfaForm
